
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["alert-icon",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 266.8 238.35"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M133.4 204.28a14.1 14.1 0 1114.1-14.1 14.1 14.1 0 01-14.1 14.1zm17-124.81l-4.28 74.63a12.8 12.8 0 01-.08 1.35 12.67 12.67 0 01-25.14.2v-.03a12.77 12.77 0 01-.1-1.58v-.14l-4.23-74a17.19 17.19 0 01-.17-2.39v-.47a17.06 17.06 0 0134.11.48 17.23 17.23 0 01-.16 1.95z"}}),_c('path',{attrs:{"d":"M261.25 197.34L157.07 16.91C150.56 5.62 141.98 0 133.4 0s-17.16 5.62-23.67 16.91L5.55 197.34c-13 22.56-2.36 41 23.67 41h208.35c26.04.01 36.7-18.44 23.68-41zm-14.38 19c-.32.42-3 2.13-9.29 2.13H29.23c-6.33 0-9-1.71-9.27-2.1s-.36-3.63 2.8-9.12L126.93 26.84c3.16-5.47 6-6.92 6.45-7s3.33 1.51 6.49 7l104.17 180.43c3.17 5.49 3.01 8.64 2.82 9.08z"}})])
          )
        }
      }
    